import { AppBar, AppBarProps, styled } from "@mui/material";
import { ColorClasses } from "components/styles/ColorClasses";
import * as React from "react";

type MprcAppBarProps = AppBarProps & { headerColor?: MprcColorsExtended; };

const AppBarStyled = styled(AppBar,
    {
        shouldForwardProp: (propName: string) => propName != "headerColor"
    })<MprcAppBarProps>(
        ({ theme, headerColor }) => (
            {
                color: theme.palette.primary.main,
                backgroundColor: ColorClasses(theme)[headerColor!].color,
                boxShadow: "none",
                "& .MuiInputBase-root": {
                    color: ColorClasses(theme)[headerColor!].color
                }
            })
    );

export const MprcAppBar: React.FC<MprcAppBarProps> = ({ children, color = "default", headerColor = "white", ...props }) => {
    return (
        <AppBarStyled {...props} color={color} headerColor={headerColor}>
            {children}
        </AppBarStyled>
    );
};
